import React, { Component } from 'react';
import './about.scss';

export default class About extends Component {
    render() {
        return (
            <div className='row about'>
                <div className='col mt-3'>
                    <div className='row'>
                        <div className='col-md-6 col-padding  d-inline-block'>
                            <div className='row w-100'>
                                <div className='col-md-12 m-2 text-center'>
                                    <span className='about-main'>About Us</span>
                                    <hr className='w-75 bg-danger' />
                                </div>
                            </div>
                            <div className='row'>
                                <span className='about-main-words text-center w-75'>
                                    Decade trucking is a 100% black owned company. We believe in old style tradition
                                    with new style technology. As a smaller trucking company we know that to be
                                    competitive we must offer a service that is superior to other companies. We know
                                    from experience that shippers and receivers struggle at times to schedule shipments,
                                    co-ordinate pickup & delivery times and make on time deliveries. Decade Trucking, is
                                    very proud of its 99.9% on time deliveries. We accomplish this by purchasing and
                                    maintaining state of the art equipment; hiring professional, experienced drivers;
                                    and communicating with our drivers on a daily one-on-one basis. We still believe
                                    that a handshake and our word is as good as a contract.
                                </span>
                            </div>
                            <div className='row w-100'>
                                <div className='col-md-12 mt-3 text-center'>
                                    <span className='about-main'>Vision</span>
                                    <hr className='w-75 bg-danger' />
                                </div>
                            </div>
                            <div className='row'>
                                <span className='about-main-words text-center w-75'>
                                    To be the leading boutique logistics partner of choice in south africa
                                </span>
                            </div>
                            <div className='row w-100'>
                                <div className='col-md-12 mt-3 text-center'>
                                    <span className='about-main'>Mission</span>
                                    <hr className='w-75 bg-danger' />
                                </div>
                            </div>
                            <div className='row'>
                                <span className='about-main-words text-center w-75'>
                                    To deliver on exceptional customer experience everyday once customer at a time.
                                </span>
                            </div>
                            <div className='row w-100'>
                                <div className='col-md-12 mt-3 text-center'>
                                    <span className='about-main'>Value Statement</span>
                                    <hr className='w-75 bg-danger' />
                                </div>
                            </div>
                            <div className='row'>
                                <span className='about-main-words text-center w-75'>
                                    We promote honesty, integrity and openess in all we do.
                                </span>
                            </div>
                        </div>
                        <div className='col-md-6 about-img-background' />
                    </div>
                </div>
            </div>
        );
    }
}
